"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16EyeHiddenLine = function Svg16EyeHiddenLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.354 3.293a1 1 0 0 1 1.414 0l3.514 3.514A9.02 9.02 0 0 1 12 6c3.637 0 6.787 2.203 8.846 5.466a1 1 0 0 1 0 1.068c-.898 1.423-2.004 2.645-3.267 3.57l3.189 3.189a1 1 0 0 1-1.414 1.414l-16-16a1 1 0 0 1 0-1.414zm6.472 5.059l1.304 1.303a2.5 2.5 0 0 1 3.214 3.214l1.8 1.8c.982-.665 1.88-1.566 2.655-2.669C17.02 9.468 14.589 8 12 8c-.741 0-1.47.12-2.174.352z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    d: "M5.033 9.093a13.8 13.8 0 0 0-1.879 2.373 1 1 0 0 0 0 1.068C5.213 15.797 8.363 18 12 18c.602 0 1.19-.06 1.763-.176L11.94 16c-2.566-.023-4.973-1.488-6.738-4 .386-.55.803-1.049 1.245-1.493L5.033 9.093z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16EyeHiddenLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16EyeHiddenLine;
exports.default = _default;